/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownEmploymentStatus } from '../models/db_DropdownEmploymentStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EmploymentStatuses {
    /**
     * Get a list of employment statuses
     * @returns db_DropdownEmploymentStatus OK
     * @throws ApiError
     */
    public static listEmploymentStatuses(): CancelablePromise<Array<db_DropdownEmploymentStatus>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/employment-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
